import type React from "react";

import { twResolve } from "@/helpers/tw-resolve";

import { fieldControlStateVariants } from "./field-control";

export type ColorInputProps = Omit<React.InputHTMLAttributes<HTMLInputElement>, "className" | "type"> & {
  invalid?: boolean;
};

export function ColorInput({ invalid, readOnly, disabled, ...props }: ColorInputProps): React.ReactNode {
  return (
    <input
      {...props}
      className={twResolve(
        "size-control-md shrink-0 appearance-none rounded-md border border-border-secondary bg-background-default p-space-xs text-body disabled:bg-background-secondary disabled:text-text-disabled",
        fieldControlStateVariants({ invalid }),
        (disabled || readOnly) && "bg-background-secondary text-text-secondary hover:border-border-secondary",
      )}
      aria-invalid={invalid}
      type="color"
      readOnly={readOnly}
      disabled={disabled || readOnly}
    />
  );
}
